import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'bm-password',
  templateUrl: 'bm-password.component.html',
  styleUrls: ['bm-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      // tslint:disable-next-line:no-forward-ref
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true,
    },
  ],
})
/**
 * Password input with an icon to toggle view/hide
 */
export class PasswordInputComponent implements ControlValueAccessor {
  @Input() public value: string | null = null;
  @Input() public disabled!: boolean;
  @Input() public displayButton = true;

  @Input() public hide = true;

  @Output() public toggleHide = new EventEmitter<boolean>();
  @Output() public passwordChange = new EventEmitter<string>();

  @ViewChild('input', { read: ElementRef, static: true })
  private _input!: ElementRef<HTMLInputElement>;

  private _onChangeCb!: (val: string) => void;
  private _onTouchCb!: () => void;

  constructor(private _cdr: ChangeDetectorRef) {}

  public writeValue(value: string) {
    this.value = value;
    this._cdr.markForCheck();
  }

  public registerOnChange(fn: (val: string) => void) {
    this._onChangeCb = fn;
  }

  public registerOnTouched(fn: () => void) {
    this._onTouchCb = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  public onInputChange(e: Event) {
    const { value } = e.target as HTMLInputElement;

    if (this._onChangeCb) {
      this._onChangeCb(value);
    }

    this.passwordChange.emit(value);
  }

  public onInputBlur() {
    if (this._onTouchCb) {
      this._onTouchCb();
    }
  }

  public focus() {
    if (this._input && this._input.nativeElement) {
      this._input.nativeElement.focus();
    }
  }

  public onToggleClick(e: Event) {
    e.preventDefault();
    this.hide = !this.hide;
    this.toggleHide.emit(this.hide);
  }

  public getInputType() {
    return this.hide ? 'password' : 'text';
  }
}
